import { Injectable } from '@angular/core';
import {NavigationExtras, Params, Router} from '@angular/router';
import { Location } from '@angular/common';
import { ContextService } from './ctx.service';
import { EventsService } from './events.service';

@Injectable({
  providedIn: 'root'
})
export class NavService {

  constructor(
    private location: Location,
    private ctx: ContextService,
    private router: Router,
    private event: EventsService
  ) {
  }

  back(): void {
    this.location.back();
  }

  navigateWithBackButton(url: string, opts?: { headerTitle: string; }): void {
    const back = !this.ctx.isDesktop;
    this.event.backEvent$.next(false);
    this.router.navigate([url], { state: { back, headerTitle: opts?.headerTitle } });
  }

  navTo(url: string, extras?: NavigationExtras): void {
    this.event.backEvent$.next(false);
    this.router.navigate([url], extras);
  }

  getQueryParams(): Params {
    return this.router.getCurrentNavigation()?.extractedUrl?.queryParams || {};
  }

  getQueryParam(param: string): string {
    const params = this.router.getCurrentNavigation()?.extractedUrl?.queryParams || {};
    return params[param];
  }

  getLocationPath() {
    return this.router.url.slice(1);
  }
}
